/**
 * Action types for Multi psk functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle user authentication.
 */

export const GET_MULTI_PSK = 'GET_MULTI_PSK';
export const GET_MULTI_PSK_SUCCESS = 'GET_MULTI_PSK_SUCCESS';
export const GET_MULTI_PSK_FAIL = 'GET_MULTI_PSK_FAIL';

export const GET_MULTI_PSK_TIP = 'GET_MULTI_PSK_TIP';
export const GET_MULTI_PSK_TIP_SUCCESS = 'GET_MULTI_PSK_TIP_SUCCESS';
export const GET_MULTI_PSK_TIP_FAIL = 'GET_MULTI_PSK_TIP_FAIL';

export const DELETE_MULTI_PSK = 'DELETE_MULTI_PSK';
export const DELETE_MULTI_PSK_SUCCESS = 'DELETE_MULTI_PSK_SUCCESS';
export const DELETE_MULTI_PSK_FAIL = 'DELETE_MULTI_PSK_FAIL';
export const ADD_MULTI_PSK = 'ADD_MULTI_PSK';
export const ADD_MULTI_PSK_COMPLETE = 'ADD_MULTI_PSK_COMPLETE';

export const GET_VIEW_MULTI_PSK = 'GET_VIEW_MULTI_PSK';
export const GET_VIEW_MULTI_PSK_SUCCESS = 'GET_VIEW_MULTI_PSK_SUCCESS';
export const GET_VIEW_MULTI_PSK_FAIL = 'GET_VIEW_MULTI_PSK_FAIL';

export const EDIT_VIEW_MULTI_PSK = 'EDIT_VIEW_MULTI_PSK';
export const EDIT_VIEW_MULTI_PSK_COMPLETE = 'EDIT_VIEW_MULTI_PSK_COMPLETE';
export const EDIT_VIEW_MULTI_PSK_FAIL = 'EDIT_VIEW_MULTI_PSK_FAILED';
export const RESET_EDIT_PSK = 'RESET_EDIT_PSK';
